import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Storage for static keys of previously connected peers.
 */


var Keycache = /*#__PURE__*/function () {
  function Keycache() {
    _classCallCheck(this, Keycache);

    _defineProperty(this, "storage", new Map());
  }

  _createClass(Keycache, [{
    key: "store",
    value: function store(peerId, key) {
      this.storage.set(peerId.id, key);
    }
  }, {
    key: "load",
    value: function load(peerId) {
      if (!peerId) {
        return null;
      }

      return this.storage.get(peerId.id) || null;
    }
  }, {
    key: "resetStorage",
    value: function resetStorage() {
      this.storage.clear();
    }
  }]);

  return Keycache;
}();

var KeyCache = new Keycache();
export { KeyCache };